import { Input } from '../../models/Input';
import { PaymentStatus } from './Enums';
import { ContentActionViewModel } from '../../models/viewModels/ContentActionViewModel';
import { InputViewModel } from '../../models/viewModels/InputViewModel';
import { ActionViewModel } from '../../models/viewModels/ActionViewModel';
import { ActionType } from '../../models/Action';
import { SetVariableActionSettings } from '../../models/SetVariableActionSettings';
import { ExecuteScriptActionSettings } from '../../models/ExecuteScriptActionSettings';
import { SendRawMessageActionSettings } from '../../models/SendRawMessageActionSettings';
import { PAYMENT_GENERATE_COMPONENT } from '../PaymentConstants';
import { TrackEventActionSettings } from '../../models/TrackEventActionSettings';
export const contentActionsPayment = (textContent) => [
    new ContentActionViewModel({
        input: InputViewModel.create(textContent, new Input({ bypass: true }), false),
    }),
];
export const getPaymentConfiguration = () => {
    return {};
};
export const leavingPaymentActions = () => {
    const actions = [
        new ActionViewModel({
            type: ActionType.SetVariable,
            $title: 'SetConfigurationData',
            settings: new SetVariableActionSettings({
                variable: 'configurationData',
                value: '{}',
            }),
        }),
        new ActionViewModel({
            type: ActionType.SetVariable,
            $title: 'SetPaymentMethodData',
            settings: new SetVariableActionSettings({
                variable: 'paymentMethodData',
                value: '{}',
            }),
        }),
        new ActionViewModel({
            type: ActionType.SetVariable,
            $title: 'SetCustomizeData',
            settings: new SetVariableActionSettings({
                variable: 'customizeData',
                value: '{}',
            }),
        }),
        // Process configuration data and generate WhatsApp order_details
        new ActionViewModel({
            type: ActionType.ExecuteScript,
            $title: 'GenerateWhatsAppOrderDetails',
            settings: new ExecuteScriptActionSettings({
                function: 'run',
                source: `const run = (configurationData, customizeData, paymentMethodData) => {            
                    let productType = "digital";
                    let referenceId = "";
                    let items = [];

                    try {
                        const refMatch = configurationData && configurationData.match(/"referenceId"\\s*:\\s*"([^"]+)"/);
                        const typeMatch = configurationData && configurationData.match(/"productType"\\s*:\\s*"([^"]+)"/);
                        referenceId = refMatch ? refMatch[1] : "";
                        productType = typeMatch ? typeMatch[1] : "digital";

                        const itemsMatch = configurationData && configurationData.match(/"items"\\s*:\\s*"\\[(.+?)\\]"/s);
                        
                        if (itemsMatch) {

                            let itemsStr = itemsMatch[1];

                            itemsStr = itemsStr.replace(/\\\\\"/g, '"').replace(/\\"/g, '"');
                            
                            const objectRegex = /\\{[^{}]*\\{[^{}]*\\}[^{}]*\\}/g;
                            const matches = itemsStr.match(objectRegex);

                            if (matches) {
                                for (let i = 0; i < matches.length; i++) {
                                    const part = matches[i].trim();
                                    const retailerMatch = part.match(/"retailer_id"\\s*:\\s*"([^"]+)"/);
                                    const nameMatch = part.match(/"name"\\s*:\\s*"([^"]+)"/);
                                    const valueMatch = part.match(/"value"\\s*:\\s*(\\d+)/);
                                    const quantityMatch = part.match(/"quantity"\\s*:\\s*(\\d+)/);

                                    // Só adiciona se todos os campos essenciais existirem
                                    if (retailerMatch && nameMatch && valueMatch && quantityMatch) {
                                        items.push({
                                            retailer_id: retailerMatch[1],
                                            name: nameMatch[1],
                                            amount: {
                                                value: parseInt(valueMatch[1]),
                                                offset: 100
                                            },
                                            quantity: parseInt(quantityMatch[1])
                                        });
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        items = [];
                    }

                    let totalValue = 0;
                    for (let i = 0; i < items.length; i++) {
                        totalValue += items[i].amount.value * items[i].quantity;
                    }

                    let textBody = "";
                    let textFooter = "";
                    if (customizeData && typeof customizeData === "string") {
                        const customData = JSON.parse(customizeData);
                        textBody = customData.textBody || textBody;
                        textFooter = customData.textFooter || textFooter;
                    }

                    let paymentSettings = [];
                    if (paymentMethodData && typeof paymentMethodData === "string") {
                        try {
                            const paymentData = JSON.parse(paymentMethodData);
                            
                            if (paymentData.method1 && paymentData.method1.type) {
                                const method1 = paymentData.method1;
                                if (method1.type === "pixcopycode" && method1.config) {
                                    paymentSettings.push({
                                        "type": "pix_dynamic_code",
                                        "pix_dynamic_code": {
                                            "code": method1.config.pixCode || "",
                                            "merchant_name": method1.config.business || "",
                                            "key": method1.config.pixKey || method1.config.business || "",
                                            "key_type": (method1.config.keyType || "EMAIL").toUpperCase()
                                        }
                                    });
                                } else if (method1.type === "paymentlink" && method1.config) {
                                    paymentSettings.push({
                                        "type": "payment_link",
                                        "payment_link": {
                                            "uri": method1.config.httpsLink || method1.config.paymentUrl || ""
                                        }
                                    });
                                } else if (method1.type === "barcode" && method1.config) {
                                    paymentSettings.push({
                                        "type": "boleto",
                                        "boleto": {
                                            "digitable_line": method1.config.boletoCode || ""
                                        }
                                    });
                                }
                            }
                                
                            if (paymentData.showMethod2 && paymentData.method2 && paymentData.method2.type) {
                                const method2 = paymentData.method2;
                                if (method2.type === "pixcopycode" && method2.config) {
                                    paymentSettings.push({
                                        "type": "pix_dynamic_code", 
                                        "pix_dynamic_code": {
                                            "code": method2.config.pixCode || "",
                                            "merchant_name": method2.config.business || "",
                                            "key": method2.config.pixKey || method2.config.business || "",
                                            "key_type": (method2.config.keyType || "EMAIL").toUpperCase()
                                        }
                                    });
                                } else if (method2.type === "paymentlink" && method2.config) {
                                    paymentSettings.push({
                                        "type": "payment_link",
                                        "payment_link": {
                                            "uri": method2.config.httpsLink || method2.config.paymentUrl || ""
                                        }
                                    });
                                } else if (method2.type === "barcode" && method2.config) {
                                    paymentSettings.push({
                                        "type": "boleto",
                                        "boleto": {
                                            "digitable_line": method2.config.boletoCode || ""
                                        }
                                    });
                                }
                            }
                        } catch (e) {
                            paymentSettings = [];
                        }
                    }
                        
                    const parsedJSON = {
                        "type": "interactive",
                        "interactive": {
                            "type": "order_details",
                            "body": {
                                "text": textBody
                            },
                            "footer": {
                                "text": textFooter
                            },
                            "action": {
                                "name": "review_and_pay",
                                "parameters": {
                                    "reference_id": referenceId,
                                    "type": productType === "fisico" ? "physical-goods" : "digital-goods",
                                    "payment_type": "br",
                                    "currency": "BRL",
                                    "total_amount": {
                                        "value": totalValue,
                                        "offset": 100
                                    },
                                    "order": {
                                        "status": "pending",
                                        "items": items,
                                        "subtotal": {
                                            "value": totalValue,
                                            "offset": 100
                                        }
                                    },
                                    "payment_settings": paymentSettings
                                }
                            }
                        }
                    };

                    const isValidCPF = function(cpf) {
                        const cleaned = cpf.replace(/\\D/g, '');
                        return (
                            /^\\d{11}$/.test(cleaned) &&
                            !new RegExp('(\\d)\\1{10}').test(cleaned)
                        );
                    };
                    const isValidCNPJ = function(cnpj) {
                        const cleaned = cnpj.replace(/\\D/g, '');
                        return (
                            /^\\d{14}$/.test(cleaned) &&
                            !new RegExp('(\\d)\\1{13}').test(cleaned)
                        );
                    };
                    const isValidEmail = (email) => {
                        return /^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$/.test(email);
                    };
                    const isValidLink = (url) => {
                        const cleaned = (url || '').trim();
                        const regex = /^(https?:\\/\\/)(?!javascript:|data:)(?:[A-Za-z0-9-._~%]+@)?(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\\.)+[A-Za-z]{2,}|localhost|\\d{1,3}(?:\\.\\d{1,3}){3})(?::\\d{2,5})?(?:[\\/?#][^\\s]*)?$/i;
                        return regex.test(cleaned);
                    };
                    const isValidBoleto = (boleto) => {
                        const cleaned = boleto.replace(/\\D/g, '');
                        return /^\\d{47,48}$/.test(cleaned);
                    };

                        // Validar estrutura básica
                        if (!parsedJSON.interactive || !parsedJSON.interactive.action || !parsedJSON.interactive.action.parameters) {
                            return { status: '${PaymentStatus.Error}', result: 'ORDER DETAILS JSON STRUCTURE ERROR' };
                        }                            

                        // Validar corpo de texto
                        if (!parsedJSON.interactive.body || !parsedJSON.interactive.body.text || parsedJSON.interactive.body.text.trim() === "") {
                            return { status: '${PaymentStatus.Error}', result: 'EMPTY JSON BODY ERROR' };
                        }

                        const params = parsedJSON.interactive.action.parameters;

                        // Validar referência
                        if (!params.reference_id || params.reference_id.trim() === "") {
                            return { status: '${PaymentStatus.Error}', result: 'ORDER REFERENCE ERROR' };
                        }

                        // Validar itens do pedido
                        if (!params.order || !Array.isArray(params.order.items) || params.order.items.length === 0) {
                            return { status: '${PaymentStatus.Error}', result: 'ORDER ITEMS ERROR' };
                        }

                        // Validar métodos de pagamento
                        if (!Array.isArray(params.payment_settings) || params.payment_settings.length === 0) {
                            return { status: '${PaymentStatus.Error}', result: 'PAYMENT SETTINGS ERROR' };
                        }

                        // Validar payment_settings (sempre array de 2)
                        if (parsedJSON.interactive && parsedJSON.interactive.action && parsedJSON.interactive.action.parameters) {
                            const params = parsedJSON.interactive.action.parameters;
                            if (Array.isArray(params.payment_settings)) {
                                for (let i = 0; i < params.payment_settings.length; i++) {
                                    const setting = params.payment_settings[i];
                                    if (setting.type === 'payment_link' && setting.payment_link) {
                                        if (!isValidLink(setting.payment_link.uri)) {
                                            return { status: '${PaymentStatus.Error}', result: 'PAYMENT LINK ERROR' };
                                        }
                                    } else if (setting.type === 'pix_dynamic_code' && setting.pix_dynamic_code) {
                                        const keyType = (setting.pix_dynamic_code.key_type || '').toUpperCase();
                                        const key = setting.pix_dynamic_code.key || '';
                                        if (keyType === 'CPF') {
                                            if (!isValidCPF(key)) {
                                                return { status: '${PaymentStatus.Error}', result: 'CPF ERROR' };
                                            }
                                        } else if (keyType === 'CNPJ') {
                                            if (!isValidCNPJ(key)) {
                                                return { status: '${PaymentStatus.Error}', result: 'CNPJ ERROR' };
                                            }
                                        } else if (keyType === 'EMAIL') {
                                            if (!isValidEmail(key)) {
                                                return { status: '${PaymentStatus.Error}', result: 'EMAIL ERROR' };
                                            }
                                        }
                                    } else if (setting.type === 'boleto' && setting.boleto) {
                                        if (!isValidBoleto(setting.boleto.digitable_line)) {
                                            return { status: '${PaymentStatus.Error}', result: 'BOLETO ERROR' };
                                        }
                                    }
                                }
                            }
                        }

                    return JSON.stringify(parsedJSON, null, 2);
                };`,
                inputVariables: [
                    'configurationData',
                    'customizeData',
                    'paymentMethodData',
                ],
                outputVariable: 'orderDetailsJSON',
            }),
        }),
        // Validar se o JSON foi gerado com sucesso e definir PAYMENT_GENERATE_COMPONENT
        new ActionViewModel({
            type: ActionType.ExecuteScript,
            $title: 'ValidateOrderDetailsAndSetStatus',
            settings: new ExecuteScriptActionSettings({
                function: 'run',
                source: `const run = (orderDetailsJSON) => {
                      try {
                            const parsedJSON = JSON.parse(orderDetailsJSON);                          

                            if (
                                parsedJSON.type === "interactive" &&
                                parsedJSON.interactive &&
                                parsedJSON.interactive.type === "order_details"
                            ) {
                                return '${PaymentStatus.Success}';
                            }

                            return '${PaymentStatus.Error}';
                        } catch (e) {
                            return '${PaymentStatus.Error}';
                        }
                    };`,
                inputVariables: ['orderDetailsJSON'],
                outputVariable: PAYMENT_GENERATE_COMPONENT,
            }),
        }),
        // Adiciona rastreamento de evento de pagamento
        new ActionViewModel({
            type: ActionType.TrackEvent,
            $title: 'Payments tracking',
            $invalid: false,
            settings: new TrackEventActionSettings({
                category: 'payment_request',
                action: 'studio_payment_request',
                extras: {
                    reference_id: '{{orderDetailsJSON@interactive.action.parameters.reference_id}}',
                    type: '{{orderDetailsJSON@interactive.action.parameters.type}}',
                    total_amount: '{{orderDetailsJSON@interactive.action.parameters.total_amount.value}}',
                    items: '{{orderDetailsJSON@interactive.action.parameters.order.items}}',
                    subtotal: '{{orderDetailsJSON@interactive.action.parameters.order.subtotal.value}}',
                    payment_settings: '{{orderDetailsJSON@interactive.action.parameters.payment_settings}}',
                    contact_name: '{{contact.name}}',
                    error_status: '{{orderDetailsJSON@status}}',
                    error_result: '{{orderDetailsJSON@result}}',
                },
            }),
        }),
        // Enviar WhatsApp order_details JSON
        new ActionViewModel({
            type: ActionType.SendRawMessage,
            $title: 'EnviarOrderDetailsWhatsApp',
            settings: new SendRawMessageActionSettings({
                type: 'application/json',
                rawContent: '{{orderDetailsJSON}}',
                metadata: {},
            }),
        }),
    ];
    return actions;
};
export const afterStateChangedPaymentActions = [];
export const localCustomActions = [];
